import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';



const Order = () => {
	const { t } = useTranslation([ 'web', 'links' ]);

	return (
		<div className='footer-menu order-section'>

			<Link to={t('footer.preContractualInfo', { ns: 'links' })} className='disable-selection' target='_blank'>
				{t('layouts.footer.orderSection.preContractualInfo')}
			</Link>

			<Link to={t('footer.consumerTerms', { ns: 'links' })} className='disable-selection' target='_blank'>
				{t('layouts.footer.orderSection.consumerTerms')}
			</Link>

			<Link to={t('footer.veterinaryTerms', { ns: 'links' })} className='disable-selection' target='_blank'>
				{t('layouts.footer.orderSection.veterinaryTerms')}
			</Link>

			<Link to={t('footer.complaintForm', { ns: 'links' })} className='disable-selection' target='_blank'>
				{t('layouts.footer.orderSection.complaintForm')}
			</Link>

			<Link to={t('footer.withdrawalForm', { ns: 'links' })} className='disable-selection' target='_blank'>
				{t('layouts.footer.orderSection.withdrawalForm')}
			</Link>

			<Link to={t('footer.gdpr', { ns: 'links' })} className='disable-selection' target='_blank'>
				{t('layouts.footer.orderSection.gdpr')}
			</Link>

		</div>
	);
}

export default Order;